import { useBreakpoints, View } from 'dripsy';
import { ViewProps } from 'react-native';

export default function ListItemWrapper(props: ViewProps) {
  const breakpoints = useBreakpoints();

  return (
    <View
      sx={{
        width: [undefined, breakpoints[1]],
        alignSelf: [undefined, 'center'],
      }}
      {...props}
    />
  );
}
